import React from "react";

import { OperationType, TaxWarningProps } from "./types";
import { useGetUserTaxes } from "hooks/withholdings/useGetUserTaxes";
import classNames from "classnames";
import { ReactComponent as WarningIcon } from "assets/images/icons/warning.svg";
import { messages } from "./messages";
import { FormattedMessage } from "react-intl";

const getOperationTypeMessage = (operation: OperationType) => {
  switch (operation) {
    case "credit":
      return messages.creditWarning;
    case "debit":
      return messages.debitWarning;
    default:
      break;
  }
};

export const TaxWarning: React.FC<TaxWarningProps> = ({
  paymentNetworkId,
  className,
  operationType,
  tickerId,
}) => {
  const { data: taxes } = useGetUserTaxes();

  const tax = taxes?.find((t) => {
    return (
      t.payment_network_id === paymentNetworkId && t.apply_to === operationType
    );
  });

  return tax ? (
    <div
      className={classNames(
        "flex items-center text-xs font-semibold text-[--milkylb-color-neutral-400]",
        className,
      )}
    >
      <WarningIcon className="shrink-0" />{" "}
      <p className="ml-2">
        <FormattedMessage
          {...getOperationTypeMessage(operationType)}
          values={{
            tickerId,
            amount: (+tax.amount * 100).toString(),
          }}
        />
      </p>
    </div>
  ) : null;
};
